// legal.js — the Burning Man disclaimer, in exactly one place.
//
// The Burning Man API/dataset Terms of Service quote a specific sentence and require it "in a
// prominent location within your App and on any webpage from which your App may be downloaded":
//
//   https://innovate.burningman.org/terms-of-service-for-burning-man-apis-and-datasets/
//
// It is QUOTED text in the ToS, so it is reproduced here verbatim — do not reword it, do not
// append to this string, and do not interpolate the product name into it. Three surfaces used to
// carry three different paraphrases ("endorsed by", "sponsored by", "verified by"); this constant
// exists so that cannot drift again.
export const BM_DISCLAIMER =
  'This app is not affiliated, endorsed, or verified by Burning Man Project.';

// Black Rock City LLC was named in the earlier paraphrases. The ToS sentence names only Burning Man
// Project, so the LLC is covered by this separate sentence rather than by editing the quoted one.
// Used on the legal pages only, where completeness matters more than brevity.
export const BM_DISCLAIMER_EXTRA = 'The same applies to Black Rock City LLC.';
